var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 49,
    viewBox: "0 0 113 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.125,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1875,
    width: 28.125,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84.375,
    width: 28.125,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 16.9922,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1875,
    y: 7,
    width: 16.9922,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.375,
    y: 7,
    width: 16.9922,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 19.5,
    width: 28.125,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1875,
    y: 19.5,
    width: 28.125,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 84.375,
    y: 19.5,
    width: 28.125,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 26.5,
    width: 16.9922,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1875,
    y: 26.5,
    width: 16.9922,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 84.375,
    y: 26.5,
    width: 16.9922,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    y: 39,
    width: 28.125,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1875,
    y: 39,
    width: 28.125,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 84.375,
    y: 39,
    width: 28.125,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 46,
    width: 16.9922,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1875,
    y: 46,
    width: 16.9922,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 84.375,
    y: 46,
    width: 16.9922,
    height: 3,
    rx: 1.5,
    fill: "#EDE9E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderContent);
export default __webpack_public_path__ + "static/media/folder-content.1b8bdb02f789efd274f16a5fad2cd13a.svg";
export { ForwardRef as ReactComponent };